import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { PAP } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-verification',
  templateUrl: 'pap-verification.component.html',
  styleUrls: ['./pap-verification.component.less', '../../shared/common.less'],
})

export class PapVerificationComponent implements OnInit {
  @Input() papValues: PAP;
  @Input() expandedView: boolean[] = [];
  @Input() verificationPercentage: number = 0;
  @Input() validatedCategoriesCount: number = 0;
  @Output() papValuesChange = new EventEmitter<PAP>();
  @Output() numberOfCollegesChanges = new EventEmitter<number>();
  @Output() editRequested = new EventEmitter<string>();
  @Output() validatedComponents = new EventEmitter<number>();

  needPap: boolean = true;
  informationValidated: boolean = false;
  employerValidated: boolean = false;
  unionValidated: boolean = false;
  lengthValidated: boolean = false;
  periodValidated: boolean = false;
  headcountValidated: boolean = false;
  collegeValidated: boolean = false;
  applicationValidated: boolean = false;
  yearValidated: boolean = false;
  validationPercentage: number = 0;

  constructor(
    private router: Router,
  ) { }

  onValidatedComponentsChange(validatedCount: number) {
    this.validatedComponents.emit(validatedCount);
  }

  onPapValuesChange() {
    this.papValuesChange.emit(this.papValues);
  }

  onNumberOfCollegesChanges() {
    this.numberOfCollegesChanges.emit(this.papValues.headcount.numberOfColleges);
  }

  onInformationComponentValidated(isValidated: boolean) {
    this.informationValidated = isValidated;
    this.getValidationPercentage();
  }

  onEmployerComponentValidated(isValidated: boolean) {
    this.employerValidated = isValidated;
    this.getValidationPercentage();
  }

  onUnionComponentValidated(isValidated: boolean) {
    this.unionValidated = isValidated;
    this.getValidationPercentage();
  }

  onLengthComponentValidated(isValidated: boolean) {
    this.lengthValidated = isValidated;
    this.getValidationPercentage();
  }

  onPeriodComponentValidated(isValidated: boolean) {
    this.periodValidated = isValidated;
    this.getValidationPercentage();
  }

  onHeadcountComponentValidated(isValidated: boolean) {
    this.headcountValidated = isValidated;
    this.getValidationPercentage();
  }

  onCollegeComponentValidated(isValidated: boolean) {
    this.collegeValidated = isValidated;
    this.getValidationPercentage();
  }

  onApplicationComponentValidated(isValidated: boolean) {
    this.applicationValidated = isValidated;
    this.getValidationPercentage();
  }

  onYearComponentValidated(isValidated: boolean) {
    this.yearValidated = isValidated;
    this.getValidationPercentage();
  }

  getValidationPercentage() {
    const validations = [
      this.informationValidated,
      this.employerValidated,
      this.unionValidated,
      this.lengthValidated,
      this.periodValidated,
      this.headcountValidated,
      this.collegeValidated,
      this.applicationValidated,
      this.yearValidated
    ];
    
    const validatedCount = validations.filter(v => v === true).length;
    const totalCount = validations.length;
    
    
    this.validationPercentage = Math.round((validatedCount / totalCount) * 100);
  }

  onYearEditRequested() {
    this.editRequested.emit('election-year');
  }

  onInformationEditRequested() {
    this.editRequested.emit('election-information');
  }

  onEmployerEditRequested() {
    this.editRequested.emit('election-employer');
  }

  onUnionEditRequested() {
    this.editRequested.emit('election-union');
  }

  onLengthEditRequested() {
    this.editRequested.emit('election-length');
  }

  onPeriodEditRequested() {
    this.editRequested.emit('election-period');
  }

  onHeadcountEditRequested() {
    this.editRequested.emit('election-headcount');
  }

  onCollegeEditRequested() {
    this.editRequested.emit('election-colleges');
  }

  onApplicationEditRequested() {
    this.editRequested.emit('election-application');
  }

  goToPollCreation() {
    this.router.navigate(['/poll-creation']);
  }

  ngOnInit(): void {
  }
}
